import { useContext, useState } from "react";
import { HGContext } from "../../helpers/globals";
import { ExportModalLazy } from "../congregation/async";
import { NavMenu } from "./NavMenu";

export function NavCongregation() {
  const ctx = useContext(HGContext);
  const [showExportModal, setShowExportModal] = useState(false);
  const hasE2eKey = !!ctx.globals.e2eKey;

  return (
    <>
      {showExportModal && <ExportModalLazy show={showExportModal} setShow={setShowExportModal} />}
      <NavMenu
        area="congregation"
        runtime={{ hasE2eKey }}
        onAction={(a) => {
          if (a === "export") setShowExportModal(true);
        }}
      />
    </>
  );
}
